import { render, staticRenderFns } from "./DocBody.vue?vue&type=template&id=58f52e10&"
import script from "./DocBody.vue?vue&type=script&lang=js&"
export * from "./DocBody.vue?vue&type=script&lang=js&"
import style0 from "./DocBody.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports